import React, { useEffect, useState } from "react";
import openIcon from "../../components/icon/assets/preview-close.svg";
import closeIcon from "../../components/icon/assets/preview-open.svg";
import "./password-input.component.css";
import { useTranslation } from "react-i18next";

interface PasswordInputProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  errorMessages?: string;
  setIsValid: (value: boolean) => void;
}

export const PHKLReEnterPasswordInput: React.FC<PasswordInputProps> = ({
  value,
  onChange,
  placeholder,
  errorMessages,
  label,
  setIsValid,
}) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const valueChange = (reEnterpassword: string) => {
    setIsValid(!!reEnterpassword);
    onChange(reEnterpassword);
  };

  return (
    <div className={`mb-4`}>
      <label
        htmlFor="password"
        className="block font-semibold text-gray-800 font-body text-sm leading-5 mb-1"
      >
        {label}
      </label>
      <div className={"flex items-center w-full border-b focus:outline-none pb-2 border-gray-300"}>
        <input
          type={showPassword ? "text" : "password"}
          className="w-full border-none focus:outline-none"
          placeholder={placeholder}
          value={value}
          onChange={(e) => valueChange(e.target.value)}
          required
        />
        <span onClick={togglePasswordVisibility}>
          <img src={showPassword ? openIcon : closeIcon} alt="" className="w-5 h-5" />
        </span>
      </div>
      {errorMessages && <div className="text-[#E8192C] text-xs">{errorMessages}</div>}
    </div>
  );
};
